export default __webpack_public_path__ + "a6b03692c92cd64fab5e421c50d45a79.png";